import React, { useEffect, useState, useCallback } from "react";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import FileUploadAndCrop from "../../components/FileUploadAndCrop/FileUploadAndCrop";
import InfoWindow from "../../components/InfoWindow/InfoWindow";
import Loader from "../../components/Loader/Loader";
import getDate from "../../helpers/getDate";
import useCurrentMediaType from "../../hooks/currentMediaType";
import { useResponceChecker } from "../../hooks/useResponceChecker";
import { addFc, deleteFc, editFc, getFcItem } from "../../redux/actions/fc";
import { uploadFile } from "../../redux/actions/file";
import Map from "./Map/Map";
import axios from "axios";
import formatTime from "../../helpers/formatTime";



const FCEditPage = () => {
  const [ready, setReady] = useState(false);
  const dispatch = useDispatch();
  const currentId = useParams().id;
  const [form, setForm] = useState({});
  const [arrAll, setArrAll] = useState([]);
  const navigate = useNavigate();
  const { listId } = useSelector((state) => state);
  const { fullList } = useSelector((state) => state);
  const { currentUser } = useSelector((state) => state.currentUser);
  const [hasRights,setHasRights]=useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertModal, setAlertModal] = useState(false);
  const [formRes, setFormRes] = useState(null);
  const [address, setAdress] = useState('');
  const [select, setSelect] = useState("");

  

  let options={
    uploadType:'avatar',
    initialAspectRatio:1 / 1,
    aspectRatio: 1 / 1,
    autoCropArea:1 / 1,
    height:'176px',
    width:'176px',
    size:3,
    type:'logoUrl',
    dragAbleZone:false,
    disabled:form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
  }
  let options2={
    uploadType:'avatar',
    initialAspectRatio:16 / 10,
    aspectRatio: 16 / 10,
    autoCropArea:16 / 10,
    height:'176px',
    width:'176px',
    size:3,
    type:'mainPhotoUrl',
    dragAbleZone:false,
    disabled:form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
  }
  
  const {
    msg: errorMessage,
    errorFiled,
    isError,
    isServerError,
  } = useResponceChecker(formRes);

  const selectClick = (e) => {
    if (e.target.id === select) {
      setSelect("");
    } else {
      setSelect(e.target.id);
    }
  };

  console.log(
    "errorMessage:",
    errorMessage,
    "isError:",
    isError,
    "errorFiled: ",
    errorFiled,
    "isServerError:",
    isServerError
  );

  useEffect(() => {
    if (isServerError) {
      setAlertModal(true);
      setAlertMessage(errorMessage);
    }
  }, [isServerError]);

  const initialFunc = () => {
    if(currentId=='0'){
      setForm({statusId:'6508a900-74e4-4fb2-9c9d-78acf998323f'});
      setReady(true);
    }else{
      dispatch(getFcItem({ id: currentId })).then((res) => {
        if(res.activityTypes.length>0){
          res.activityTypeIds=[];
          res.activityTypes.forEach(el=>{
            res.activityTypeIds.push(el.id)
          })
        }
        setAdress(res.address);
        setArrAll(res.location|| []);
        setForm({ ...res });
        setReady(true);
      });
    }
    
  };
  const editClick = (e) => {
    let data = {};
    data.type = e.target.accessKey;
    data.id = currentId;
    dispatch(addFc(data)).then((res) => {
      navigate(`/fcEdit/${res?.id}`);
      setReady(false);
    });
  };
  const changeStatus = (e) => {
    let data = {...form};
    data.type = e.target.accessKey;
    if(currentId!=0){
      data.id = currentId;
    }
    if(data.type==='to-moderation'){
      data.statusId='6ec9fa45-a030-43a6-88b4-c761fdf25836'
    }
    if(form.id && data.type==='to-moderation' && form.statusId!="6508a900-74e4-4fb2-9c9d-78acf998323f"){
      data.originalId=form.id;
    }

    if(data.type==='to-moderation' && (!form.name || !form.address || !form.description||  !form.tagline || form.name.length<1 || form.tagline.length<1 || form.address.length<1 || form.description.length<1) ){
      setAlertMessage('Перевірте заповненість "Назви", "Опису", "Гасла" та "Адреси" клуба');
      setAlertModal(true);
    }else{
      if((currentId!=0 && form.statusId=="6508a900-74e4-4fb2-9c9d-78acf998323f" && form.originalId)|| (currentId!=0 && form.statusId=="6508a900-74e4-4fb2-9c9d-78acf998323f" && form.createdBy.id) ){
        dispatch(editFc(data)).then((res) => {
          if(res.errors){
            setAlertModal(true);
            setAlertMessage(res.errors[0].msg);
          }else{
            if(form.originalId && data.type==='publish'){
              navigate("/fcList");
            }else{
              if(res.id){
                navigate('/fcEdit/'+res.id);
                setReady(false);
              }else{
                initialFunc();
              }
            }
          }
        });
      }
      else{
        dispatch(addFc(data)).then((res) => {
          if(res.errors){
            setAlertModal(true);
            setAlertMessage(res.errors[0].msg);
          }else{
            if(form.originalId && data.type==='publish'){
              navigate("/fcList");
            }else{
              if(res.id){
                navigate('/fcEdit/'+res.id);
                setReady(false);
              }else{
                initialFunc();
              }
            }
          }
        });
      }
      
    }
  };
  const saveEdit = useCallback(
    (data) => {
      if(Array.isArray(data)){
        let dat =form;
        dat.location=data[0].location;
        setForm(dat)
      }else{
      }
    },
    [form]
  );

  const getCurrentLocation = (lat, lon) => {
    return axios
      .get(
        `https://map.technodreams.biz/reverse?lat=${lat}&lon=${lon}&accept-language=ua&format=json`
      )
      .then((res) => {
        var address = ""
        let resource =res.data.address;
        if (resource.amenity?.length>0){
          address += `${resource.amenity}, `;
          }
        if (resource.city?.length>0){
        address += `${resource.city}`;
        }
        if (!resource.city&& resource.state?.length>0){
        address += `${resource.state}, `;
        }
        if (resource.town?.length>0){
        address += `${resource.town}`;
        }
        if (resource.village?.length>0){
          address += `${resource.village}`;
          }
      
        if (resource.road?.length>0){
        address += `, ${resource.road}`;
        }
        if (resource.building?.length>0){
          address += ` ${resource.building}`;
          }
  
        if (resource.house_number?.length>0){
        address += ` ${resource.house_number}`;
        }
        setAdress(address);
        let data=form;
        data.address=address;
        data.location=[lat, lon];

        setForm(data);
        
        return;
      })
      .catch((e) => {
        console.log(e);
        setAdress(lat.toFixed(4) +' - '+ lon.toFixed(4));
        setForm({...form,['address']:lat.toFixed(4) +' - '+ lon.toFixed(4)});
        return;
      });
  };


  const changeHandler = (e) => {
    if(e.target.id==='phone' && e.target.value.length===0 ){
      setForm({ ...form, [e.target.id]: '+'});
    }else{
      setForm({ ...form, [e.target.id]: e.target.value });
    }
  };

  const selectChoose = (e) => {
    let data = { ...form, [e.target.accessKey]: e.target.id };
    setForm(data);

    setSelect("");
    saveEdit(data);
  };

  const setSelectMassClick = (e) => {
    let data = { ...form };
    let key = e.target.accessKey;
    let id = e.target.id;
    if (!Array.isArray(data[key])) {
      data[key] = [];
    }
    if (data[key].includes(id)) {
      data[key] = data[key].filter(item => item !== id);
    } else {
      data[key].push(id);
    }
    console.log( data[key]);
    setForm(data);
  };

  const deleteClick = (e) => {
    dispatch(deleteFc({ id: currentId }))
      .then((res) => {
        navigate("/fcList");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const formDescription = useMemo(() => {
    if (form.description === null || !form.description) return "";
    return form.description;
  }, [form.description]);


  const updateArr = (ar) => {
    getCurrentLocation(ar[0],ar[1])
    setArrAll(ar);
    saveEdit(ar);
  };

  useEffect(() => {
    if(currentUser.permissions){
      const isFound = currentUser.permissions?.some(str => str === 'clubActing-'+currentId);
      if(isFound){
        setHasRights(true);
      }
    }
  }, []);

  useEffect(() => {
    if (!ready) {
      initialFunc();
    }
  }, [ready]);

  if (
    !ready ||
    !listId ||
    !listId.list ||
    (listId.list && listId.list.length == 0)
  ) {
    return <Loader />;
  } else {
    return (
      <>
        {alertModal && (
          <InfoWindow
            setModal={setAlertModal}
            message={alertMessage}
            buttonMsg={isServerError && "Оновити"}
            setClick={() => window.location.reload()}
          ></InfoWindow>
        )}
        <h1>
          Картка клубу
          <div className="headerClubSub">
            Статус: <span>{listId.list[form.statusId]}</span>
            <span className="currentStatusDivider"></span>
            {form.originalId && (
              <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/fcEdit/" + form.originalId);
                  setReady(false);
                }}
              >
                Сторінка початкового клубу
              </a>
            )}
          </div>
        </h1>
        <div className="menuFunctionLine">
          <div className="actionButtonsBlock">
            <button
              className="secondaryButtonIconTextDefault"
              onClick={() => navigate("/fcList")}
            >
              <svg>
                <use href="/images/icon24ArrowLeft.svg#icon24" />
              </svg>
              Назад
            </button>

            {(form.statusId === "6508a900-74e4-4fb2-9c9d-78acf998323f" || form.statusId ==='b7db65d3-3207-4e1d-b87d-f2ec25aeba23' )&& (
              <button
                className="primaryButtonIconTextDefault"
                accessKey="to-moderation"
                onClick={changeStatus}
              >
                <svg accessKey="to-moderation">
                  <use
                    accessKey="to-moderation"
                    href="/images/icon24CheckCircle.svg#icon24"
                  />
                </svg>
                На модерацію
              </button>
            )}

            {form.statusId === "6ec9fa45-a030-43a6-88b4-c761fdf25836" &&
              currentUser.roleId === "d379ecaa-fee7-48a4-84df-a176f47820e6" && (
                <button
                  className="primaryButtonIconTextDefault"
                  accessKey="publish"
                  onClick={changeStatus}
                >
                  <svg accessKey="publish">
                    <use
                      accessKey="publish"
                      href="/images/icon24CheckCircle.svg#icon24"
                    />
                  </svg>
                  Опублікувати
                </button>
              )}
            {form.statusId === "6ec9fa45-a030-43a6-88b4-c761fdf25836" &&
              (currentUser.roleId === "d379ecaa-fee7-48a4-84df-a176f47820e6" || 
                currentUser.id === form.createdBy.id|| hasRights)  && (
                <button
                  accessKey="to-draft"
                  className="secondaryButtonIconTextDefault"
                  onClick={changeStatus}
                >
                  <svg accessKey="to-draft">
                    <use
                      accessKey="to-draft"
                      href="/images/icon24ArrowReturn.svg#icon24"
                    />
                  </svg>
                  Зняти з публікації та редагувати
                </button>
              )}
            {(form.statusId === "e19aa583-d4c7-476c-8be7-37fa5f5710f6" ||
              form.statusId === "b7db65d3-3207-4e1d-b87d-f2ec25aeba23") &&
                (currentUser.roleId ===
                  "d379ecaa-fee7-48a4-84df-a176f47820e6" || hasRights ||
                  currentUser.id === form.createdBy.id) && (
                  <button
                    className="primaryButtonIconTextDefault"
                    accessKey="duplicate"
                    onClick={editClick}
                  >
                    <svg>
                      <use href="/images/icon24Edit.svg#icon24" />
                    </svg>
                    Редагувати
                  </button>
                )}

            {form.statusId === "e19aa583-d4c7-476c-8be7-37fa5f5710f6" &&
              (currentUser.roleId === "d379ecaa-fee7-48a4-84df-a176f47820e6" ||
                currentUser.id === form.createdBy.id) && (
                <button
                  accessKey="deactivate"
                  className="secondaryButtonIconTextDefault"
                  onClick={changeStatus}
                >
                  <svg accessKey="deactivate">
                    <use
                      accessKey="deactivate"
                      href="/images/icon24Trash.svg#icon24"
                    />
                  </svg>
                  Деактивувати
                </button>
              )}

            {form.statusId === "6508a900-74e4-4fb2-9c9d-78acf998323f" && (
              <button
                className="secondaryButtonIconTextDefault"
                onClick={deleteClick}
              >
                <svg>
                  <use href="/images/icon24Trash.svg#icon24" />
                </svg>
                Видалити
              </button>
            )}
          </div>
        </div>
        <div
          style={{ marginTop: "24px" }}
          className="pageContentHeaderDivider"
        />

        <h3 style={{ marginTop: "40px" }}>Назва і гасло клубу</h3>

        <div className="apFCSection">
          <div
            style={{ width: "486px" }}
            className={`apFCSectionItem ${
              form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                ? "apInputText apDisabled"
                : `${form.name ? "apInputText apFilled" : "apInputText"}`
            }`}
          >
            <label htmlFor="name">Назва*</label>
            <input
              id="name"
              type="text"
              disabled={
                form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
              }
              value={form.name || ''}
              onChange={changeHandler}
              onBlur={saveEdit}
            />
          </div>

          <div
            style={{ margin: "0 24x", width: "486px" }}
            className={`apFCSectionItem ${
              form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                ? "apInputText apDisabled"
                : `${form.tagline ? "apInputText apFilled" : "apInputText"}`
            }`}
          >
            <label htmlFor="tagline">Гасло клубу*</label>
            <input
              id="tagline"
              type="text"
              disabled={
                form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
              }
              value={form.tagline||''}
              onChange={changeHandler}
              onBlur={saveEdit}
            />
          </div>

          <div
            style={{ width: "180px" }}
            className={`apFCSectionItem date  apInputText
            ${
              ( form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f") ?
                "apDisabled" : (form.establishedAt && `apFilled`) || ""}
            ${(errorFiled === "establishedAt" && "apError") || ""}
            `}
          >
            <label htmlFor="establishedAt">Дата створення</label>
            <input
              id="establishedAt"
              type="date"
              lang="ua"
              disabled={
                form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
              }
              value={getDate(form.establishedAt, "yyyy/mm/dd", "-")|| ''}
              onChange={changeHandler}
              onBlur={saveEdit}
            />
            {errorFiled === "establishedAt" && <span>{errorMessage}</span>}
          </div>
        </div>

        <div className='separatedBlockClub'>
          <div className="apDropDownList" onBlur={saveEdit}>
                <label htmlFor="clubOriginTypeId">Тип клубу*</label>
                <div
                  id="clubOriginTypeId"
                  onClick={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? ""
                      : selectClick
                  }
                >
                  <input
                    id="clubOriginTypeId"
                    readOnly
                    type="text"
                    disabled={form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"} 
                    value={
                      form.clubOriginTypeId?.length > 0 ? listId.list[form.clubOriginTypeId] : ""
                    }
                  />
                  <svg id="clubOriginTypeId">
                    <use href="/images/icon24DropDown.svg#icon24" />
                  </svg>
                </div>
                {select === "clubOriginTypeId" && (
                  <div className="apOptionsList">
                    {fullList.ClubOriginalTypes.map((el) => {
                      return (
                        <div
                          id={el.id}
                          accessKey="clubOriginTypeId"
                          onClick={selectChoose}
                        >
                          {el.title}
                        </div>
                      );
                    })}
                  </div>
                )}
            </div>
            <div className="apDropDownList apFilled" style={{position:'relative', marginBottom:'49px'}}>
                        <label htmlFor="activityTypeIds">Типи активностей</label>
                        <div id="activityTypeIds" onClick={form.statusId == "6508a900-74e4-4fb2-9c9d-78acf998323f"?selectClick:''}>
                            <input
                            id="activityTypeIds"
                            readOnly
                            type="text"
                            value={'Додати активність'}
                            disabled={form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"} 
                            />
                            <svg id="activityTypeIds" onClick={selectClick}>
                            <use
                                id="activityTypeIds"
                                onClick={selectClick}
                                href="/images/icon24DropDown.svg#icon24"
                            />
                            </svg>
                        </div>
                        {select == "activityTypeIds" && (
                            <div className="apOptionsList">
                                <div
                                    id={''}
                                    key={''}
                                    className={
                                        '' === form.activityTypeIds ? "apActive" : ""
                                    }
                                    accessKey="activityTypeIds"
                                    onClick={setSelectMassClick}
                                    >
                                    </div>
                            {fullList.ActivityTypes.map((el) => {
                                return (
                                    <div
                                    id={el.id}
                                    key={el.id}
                                    className={form.activityTypeIds?.includes(el.id) ? "apActive" : ""}
                                    accessKey="activityTypeIds"
                                    onClick={setSelectMassClick}
                                    >
                                    {el.title}
                                    </div>
                                );
                            })}
                            </div>
                        )}
                        <div className="coverList">
                        {form.activityTypeIds?.length > 0  && form.activityTypeIds?.map(el => {
                          return (
                            <div className="coverItem" key={el}>
                              {listId.list[el]}
                              {form.statusId == "6508a900-74e4-4fb2-9c9d-78acf998323f" &&<div className="crossButton" onClick={() => {
                                const updatedForm = { ...form };
                                updatedForm.activityTypeIds = updatedForm.activityTypeIds.filter(item => item !== el);
                                setForm(updatedForm);
                              }}>
                                X
                              </div>}
                            </div>
                          );
                        })}
                        </div>
                        </div>

        </div>

        <h3 style={{ marginTop: "20px" }}>Логотип та опис клубу</h3>

        <div className="apFCSection">
          <div className="apFCSectionItem apFcSectionSmItem">
            {/* <div className=" videoCardCoverImageAndDrop">
              <div className="videoCardDropAreaAndHint">
                {form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" ? (
                  <></>
                ) : (
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    id="logoUrl"
                    disabled={
                      form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                    }
                    onChange={
                      form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                        ? ""
                        : inputPut
                    }
                    style={{ display: "none" }}
                  />
                )}
                <label
                  id="drop_zone"
                  htmlFor="logoUrl"
                  className={`${form.logoUrl ? "withBg" : ""} ${
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? "videoCardDropArea apDisabled"
                      : "videoCardDropArea"
                  }`}
                  style={{
                    backgroundImage: `${
                      form.logoUrl ? `url(${form.logoUrl})` : "none"
                    }`,
                  }}
                  onDrop={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? ""
                      : DropOn
                  }
                  onDragOver={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? ""
                      : dragOverHandler
                  }
                >
                  <div className="dropLabelText">
                    <svg>
                      <use href="/images/icon24Download.svg#icon24" />
                    </svg>
                    <span>
                      {form.statusId === "6508a900-74e4-4fb2-9c9d-78acf998323f"
                        ? `Перетягніть файли сюди або натисніть, щоб обрати.`
                        : "Опублікований клуб не можливо редагувати"}
                    </span>
                  </div>
                </label>

                <div className="apParkImagesHintArea">
                  <span>
                    Завантажуйте файл jpg, jpeg, png до&nbsp;10&nbsp;мегабайт.
                  </span>
                  <svg>
                    <use href="/images/icon24Info.svg#icon24" />
                  </svg>
                </div>
              </div>
            </div> */}
            <div>
              <div className="leftsideInfoStartPageHeader">
              Логотип
              </div>
            <FileUploadAndCrop options={options} saveEdit={saveEdit} form={form} setForm={setForm} image={form.logoUrl || (fullList.ClubOriginalTypes?.find(el => el.id === form.clubOriginTypeId)?.logoUrl ?? '')} setAlertMessage={setAlertMessage} setAlertModal={setAlertModal}> </FileUploadAndCrop>
            </div>
            <div style={{marginTop:'10px', marginBottom:'10px'}}>
            <div className="leftsideInfoStartPageHeader">
            Обкладинка
            </div>
            <FileUploadAndCrop options={options2} saveEdit={saveEdit} form={form} setForm={setForm} image={form.mainPhotoUrl || (fullList.ClubOriginalTypes?.find(el => el.id === form.clubOriginTypeId)?.mainPhotoUrl ?? '')} setAlertMessage={setAlertMessage} setAlertModal={setAlertModal}> </FileUploadAndCrop>
            </div>
          </div>
          <div className="apFCSectionItem apFcSectionSmItem">
            <div
              className={`apInputTextIcon
                ${
                  form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" ?
                    "apDisabled" :
                    (form.phone && `apFilled`) || ""
                } 
                ${(errorFiled === "phone" && "apError") || ""}
                `}
            >
              <label htmlFor="phone">Контактний телефон</label>
              <div>
                <input
                  id="phone"
                  type="text"
                  value={ form.phone || form?.createdBy?.phone}
                  onBlur={saveEdit}
                  disabled={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                  }
                  onChange={changeHandler}
                />
                <svg>
                  <use href="/images/icon24Edit.svg#icon24" />
                </svg>
              </div>
              {errorFiled === "phone" && <span>{errorMessage}</span>}
            </div>
            <div
              className={`apInputTextIcon
              ${
                (form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" &&
                  "apDisabled") ||
                ""
              } 
              ${(form.facebookUrl && `apFilled`) || ""} 
              ${(errorFiled === "facebookUrl" && "apError") || ""}
              `}
            >
              <label htmlFor="facebookUrl">Facebook</label>
              <div>
                <input
                  id="facebookUrl"
                  type="text"
                  onBlur={saveEdit}
                  disabled={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                  }
                  onChange={changeHandler}
                  value={form.facebookUrl|| ''}
                />
                <svg >
                  <use href="/images/facebook.svg#icon24" />
                </svg>
              </div>
              {errorFiled === "facebookUrl" && <span>{errorMessage}</span>}
            </div>
            <div
              className={`apInputTextIcon
              ${
                ( form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" &&
                  "apDisabled") ||
                ""
              } 
              ${(form.instagramUrl && `apFilled`) || ""} 
              ${(errorFiled === "instagramUrl" && "apError") || ""}
              `}
            >
              <label htmlFor="instagramUrl">Instagram</label>
              <div>
                <input
                  id="instagramUrl"
                  type="text"
                  value={form.instagramUrl|| ''}
                  onChange={changeHandler}
                  onBlur={saveEdit}
                  disabled={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                  }
                />
                <svg >
                  <use href="/images/instagram.svg#icon24" />
                </svg>
              </div>
              {errorFiled === "instagramUrl" && <span>{errorMessage}</span>}
            </div>
            <div
              className={`apInputTextIcon
              ${
                (form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" &&
                  "apDisabled") ||
                ""
              } 
              ${(form.youtubeUrl && `apFilled`) || ""} 
              ${(errorFiled === "youtubeUrl" && "apError") || ""}
              `}
            >
              <label htmlFor="youtubeUrl">YouTube</label>
              <div>
                <input
                  id="youtubeUrl"
                  onBlur={saveEdit}
                  disabled={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                  }
                  onChange={changeHandler}
                  type="text"
                  value={form.youtubeUrl|| ''}
                />
                <svg>
                  <use href="/images/youtube.svg#icon24" />
                </svg>
              </div>
              {errorFiled === "youtubeUrl" && <span>{errorMessage}</span>}
            </div>
            <div
              className={`apInputTextIcon
              ${
                (form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" &&
                  "apDisabled") ||
                ""
              } 
              ${(form.youtubeUrl && `apFilled`) || ""} 
              ${(errorFiled === "tiktocUrl" && "apError") || ""}
              `}
            >
              <label htmlFor="tiktocUrl">TikTok</label>
              <div>
                <input
                  id="tiktocUrl"
                  onBlur={saveEdit}
                  disabled={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                  }
                  onChange={changeHandler}
                  type="text"
                  value={form.tiktocUrl|| ''}
                />
                <svg>
                  <use href="/images/Sword.svg#icon24" />
                </svg>
              </div>
              {errorFiled === "tiktocUrl" && <span>{errorMessage}</span>}

            </div>
            <div
              className={`apInputTextIcon
              ${
                (form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f" &&
                  "apDisabled") ||
                ""
              } 
              ${(form.socialNetworkUrl && `apFilled`) || ""} 
              ${(errorFiled === "socialNetworkUrl" && "apError") || ""}
              `}
            >
              <label htmlFor="socialNetworkUrl">ВебСайт</label>
              <div>
                <input
                  id="socialNetworkUrl"
                  onBlur={saveEdit}
                  disabled={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                  }
                  onChange={changeHandler}
                  type="text"
                  value={form.socialNetworkUrl|| ''}
                />
                <svg>
                  <use href="/images/icon24Search.svg#icon24" />
                </svg>
              </div>
              {errorFiled === "socialNetworkUrl" && <span>{errorMessage}</span>}
            </div>
          </div>
          <div className="apFCSectionItem apFcSectionLgItem">
            <div
              style={{ width: "588px" }}
              className={
                form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323"
                  ? "apTextarea apDisabled"
                  : `${form.description ? "apTextarea apFilled" : "apTextarea"}`
              }
            >
              <label htmlFor="description">Опис*</label>
              <textarea
                id="description"
                disabled={
                  form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                }
                maxLength="2000"
                value={formDescription|| ''}
                onChange={changeHandler}
                onBlur={saveEdit}
              />
              <div>
                <span />
                <span>
                  {form.description ? form.description.length : 0}/2000
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="apFCSection">
          <Map arrAll={arrAll} disabled={form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"} updateArr={updateArr}></Map>
          <div
              className={
                 "apInputText"
              }
              style={{width:'100%'}}
            >
              <label htmlFor="title">Адреса</label>
              <input
                id="title"
                type="text"
                disabled={
                 true
                }
                value={address}
                placeholder="Оберіть адресу на карті"
              />
            </div>
            <div className='separatedBlockClub'>
            <div className="apDropDownList" onBlur={saveEdit}>
                <label htmlFor="regionId">Регіон*</label>
                <div
                  id="regionId"
                  onClick={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? ""
                      : selectClick
                  }
                >
                  <input
                    id="regionId"
                    readOnly
                    type="text"
                    disabled={form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"} 
                    value={
                      form.regionId?.length > 0 ? listId.list[form.regionId] : ""
                    }
                  />
                  <svg id="regionId">
                    <use href="/images/icon24DropDown.svg#icon24" />
                  </svg>
                </div>
                {select === "regionId" && (
                  <div className="apOptionsList">
                    {fullList.Regions.map((el) => {
                      return (
                        <div
                          id={el.id}
                          accessKey="regionId"
                          onClick={selectChoose}
                        >
                          {el.title}
                        </div>
                      );
                    })}
                  </div>
                )}
            </div>
            {form.regionId!=='ea0574da-fd62-413b-86eb-4289849abc4a' && form.regionId!=='48afac15-77e2-4ad4-8890-b518e9b13b7a' &&<>
            <div className="apDropDownList" onBlur={saveEdit}>
                <label htmlFor="districtId">Район*</label>
                <div
                  id="districtId"
                  onClick={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? ""
                      : selectClick
                  }
                >
                  <input
                    id="districtId"
                    readOnly
                    type="text"
                    disabled={form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"} 
                    value={
                      form.districtId?.length > 0 ? listId.list[form.districtId] : ""
                    }
                  />
                  <svg id="districtId">
                    <use href="/images/icon24DropDown.svg#icon24" />
                  </svg>
                </div>
                
                {select === "districtId" && (
                  <div className="apOptionsList">
                    {fullList.Districts.map((el) => {
                      if (el.regionId == form.regionId) {
                        return (
                          <div
                            key={el.title}
                            id={el.id}
                            accessKey="districtId"
                            onClick={selectChoose}
                          >
                            {el.title}
                          </div>
                        );
                      }
                    })}
                  </div>
                )}
            </div>
            <div className="apDropDownList" onBlur={saveEdit}>
                <label htmlFor="communityId">Громада*</label>
                <div
                  id="communityId"
                  onClick={
                    form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"
                      ? ""
                      : selectClick
                  }
                >
                  <input
                    id="communityId"
                    readOnly
                    type="text"
                    disabled={form.statusId !== "6508a900-74e4-4fb2-9c9d-78acf998323f"} 
                    value={
                      form.communityId?.length > 0 ? listId.list[form.communityId] : ""
                    }
                  />
                  <svg id="communityId">
                    <use href="/images/icon24DropDown.svg#icon24" />
                  </svg>
                </div>
                
                {select === "communityId" && (
                  <div className="apOptionsList">
                    {fullList.Communities.map((el) => {
                      if (el.districtId == form.districtId) {
                        return (
                          <div
                            key={el.title}
                            id={el.id}
                            accessKey="communityId"
                            onClick={selectChoose}
                          >
                            {el.title}
                          </div>
                        );
                      }
                    })}
                  </div>
                )}
            </div>
            </>}
          </div>

          


        </div>
      </>
    );
  }
};

export default FCEditPage;
